// Student-facing and sign-in text in English and Hindi. Staff screens are English for now.
export const en = {
  tagline: 'From small beginnings to top rankings.',
  taglineStudent: 'Your Village. Your Dreams. Your Rank.',
  signIn: 'Sign in',
  welcomeBack: 'Welcome back',
  signInSubtitle: 'Sign in with the roll number and password from your institute.',
  featureRank: 'Rank and percentile after every test',
  featureLanguage: 'Questions in Hindi and English',
  featureDevices: 'Works on any phone or computer',
  featureSaved: 'Every answer saved automatically',
  poweredBy: 'Powered by Testpio',
  poweredByLabel: 'Powered by',
  loginId: 'Roll number / Login ID',
  password: 'Password',
  loginIdPlaceholder: 'e.g. 101 or admin',
  passwordPlaceholder: 'Your password',
  signingIn: 'Signing in…',
  wrongInstitute: 'Institute not found. Please check the link you received.',
  instituteInactive: "This institute's account is paused. Please contact your institute.",
  forgotPassword: 'Forgot your password? Ask your teacher to reset it.',
  signOut: 'Sign out',
  home: 'Home',
  results: 'Results',
  progress: 'Progress',
  profile: 'Profile',
  hello: 'Hello, {name}',
  liveNow: 'Live now',
  live: 'Live',
  upcoming: 'Upcoming',
  pastTests: 'Past tests',
  start: 'Start test',
  resume: 'Resume test',
  viewResult: 'View result',
  resultsSoon: 'Result after release',
  missed: 'Missed',
  submitted: 'Submitted',
  opensAt: 'Opens {time}',
  startBefore: 'Start before {time}',
  questionsCount: '{n} questions',
  minutesCount: '{n} min',
  noTests: 'No tests yet. Your teacher will add them here.',
  practice: 'Practice',
  ranked: 'Ranked test',
  attemptsLeft: '{n} attempts left',
  instructions: 'Instructions',
  duration: 'Duration',
  marking: 'Marking',
  markingLine: '+{c} for correct, −{w} for wrong',
  iHaveRead: 'I have read the instructions',
  beginTest: 'Begin test',
  questionLanguage: 'Question language',
  question: 'Question',
  questionOf: 'Question {n} of {total}',
  saveNext: 'Save & Next',
  next: 'Next',
  previous: 'Previous',
  markReview: 'Mark for review',
  markNext: 'Mark for review & next',
  shortcuts: 'Keys: 1–6 choose · ← → move · M mark · C clear',
  candidate: 'Candidate',
  section: 'Section',
  unmark: 'Unmark',
  clear: 'Clear',
  submit: 'Submit test',
  allQuestions: 'All questions',
  answered: 'Answered',
  notAnswered: 'Not answered',
  notVisited: 'Not visited',
  marked: 'Marked',
  answeredMarked: 'Answered & marked',
  saved: 'Saved',
  saving: 'Saving…',
  offline: 'Offline — {n} not saved yet',
  offlineHint: 'Keep this page open. Answers save automatically when the internet returns. Answers not saved before time ends will not count.',
  timeLeft: 'Time left',
  confirmSubmit: 'Submit the test?',
  confirmSubmitText: 'You cannot change answers after submitting.',
  cancel: 'Cancel',
  yesSubmit: 'Yes, submit',
  submittedTitle: 'Test submitted',
  submittedText: 'Your answers have been saved.',
  resultAfterRelease: 'Your result will appear here when your teacher releases it.',
  backHome: 'Back to home',
  timeUp: 'Time is up',
  timeUpText: 'Your saved answers have been submitted automatically.',
  openElsewhere: 'This test is open on another device',
  openElsewhereText: 'You can continue here. The other device will stop saving answers.',
  continueHere: 'Continue here',
  fiveMinutesLeft: '5 minutes left',
  oneMinuteLeft: '1 minute left',
  loadingTest: 'Loading the test…',
  score: 'Score',
  rank: 'Rank',
  percentile: 'Percentile',
  accuracy: 'Accuracy',
  timeTaken: 'Time taken',
  correct: 'Correct',
  wrong: 'Wrong',
  skipped: 'Skipped',
  topper: 'Topper',
  average: 'Average',
  batchRank: 'Rank in {batch}',
  sections: 'Sections',
  topics: 'Topics',
  strong: 'Strong',
  needsWork: 'Needs practice',
  solutions: 'Solutions',
  yourAnswer: 'Your answer',
  correctAnswer: 'Correct answer',
  explanation: 'Explanation',
  percentCorrect: '{n}% got this right',
  bonusQuestion: 'Bonus — marks given to everyone',
  excludedQuestion: 'Removed from this test',
  notAttempted: 'Not attempted',
  shareResult: 'Share result',
  leaderboard: 'Leaderboard',
  you: 'You',
  updatedAfterCorrection: 'Updated after an answer key correction',
  all: 'All',
  badge_top10: 'Top 10',
  badge_top10pct: 'Top 10%',
  badge_rankUp: 'Up {n} ranks',
  badge_personalBest: 'Personal best',
  badge_fullMarks: 'Full marks',
  badge_firstTest: 'First test',
  testsTaken: 'Tests taken',
  bestPercentile: 'Best percentile',
  averagePercentile: 'Average percentile',
  streak: 'Test streak',
  percentileTrend: 'Your percentile over time',
  allTests: 'All tests',
  noResultsYet: 'Your progress appears after your first result.',
  language: 'Language',
  changePassword: 'Change password',
  currentPassword: 'Current password',
  newPassword: 'New password',
  passwordChanged: 'Password changed',
  save: 'Save',
  errorGeneric: 'Something went wrong. Please try again.',
  networkError: 'No internet connection.',
  tryAgain: 'Try again',
  installApp: 'Install app',
  resultCard: 'Result card',
  participants: '{n} students',
};

export type StringKey = keyof typeof en;

export const hi: Record<StringKey, string> = {
  tagline: 'छोटी शुरुआत से टॉप रैंक तक।',
  taglineStudent: 'आपका गाँव। आपके सपने। आपकी रैंक।',
  signIn: 'लॉग इन करें',
  welcomeBack: 'फिर से स्वागत है',
  signInSubtitle: 'संस्थान से मिले रोल नंबर और पासवर्ड से लॉग इन करें।',
  featureRank: 'हर टेस्ट के बाद रैंक और पर्सेंटाइल',
  featureLanguage: 'हिंदी और अंग्रेज़ी में प्रश्न',
  featureDevices: 'किसी भी फ़ोन या कंप्यूटर पर चलता है',
  featureSaved: 'हर उत्तर अपने-आप सेव',
  poweredBy: 'Testpio द्वारा संचालित',
  poweredByLabel: 'द्वारा संचालित',
  loginId: 'रोल नंबर / लॉगिन आईडी',
  password: 'पासवर्ड',
  loginIdPlaceholder: 'जैसे 101',
  passwordPlaceholder: 'आपका पासवर्ड',
  signingIn: 'लॉग इन हो रहा है…',
  wrongInstitute: 'संस्थान नहीं मिला। कृपया मिला हुआ लिंक जाँचें।',
  instituteInactive: 'इस संस्थान का खाता अभी बंद है। कृपया अपने संस्थान से संपर्क करें।',
  forgotPassword: 'पासवर्ड भूल गए? अपने शिक्षक से नया पासवर्ड बनवाएँ।',
  signOut: 'लॉग आउट',
  home: 'होम',
  results: 'परिणाम',
  progress: 'प्रगति',
  profile: 'प्रोफ़ाइल',
  hello: 'नमस्ते, {name}',
  liveNow: 'अभी चल रहे टेस्ट',
  live: 'लाइव',
  upcoming: 'आने वाले टेस्ट',
  pastTests: 'पिछले टेस्ट',
  start: 'टेस्ट शुरू करें',
  resume: 'टेस्ट जारी रखें',
  viewResult: 'परिणाम देखें',
  resultsSoon: 'परिणाम जारी होने के बाद',
  missed: 'छूट गया',
  submitted: 'जमा हो गया',
  opensAt: '{time} पर शुरू',
  startBefore: '{time} से पहले शुरू करें',
  questionsCount: '{n} प्रश्न',
  minutesCount: '{n} मिनट',
  noTests: 'अभी कोई टेस्ट नहीं है। आपके शिक्षक यहाँ टेस्ट जोड़ेंगे।',
  practice: 'अभ्यास',
  ranked: 'रैंक टेस्ट',
  attemptsLeft: '{n} प्रयास बाकी',
  instructions: 'निर्देश',
  duration: 'समय',
  marking: 'अंक योजना',
  markingLine: 'सही पर +{c}, गलत पर −{w}',
  iHaveRead: 'मैंने निर्देश पढ़ लिए हैं',
  beginTest: 'टेस्ट शुरू करें',
  questionLanguage: 'प्रश्नों की भाषा',
  question: 'प्रश्न',
  questionOf: 'प्रश्न {n} / {total}',
  saveNext: 'सेव करें और आगे',
  next: 'आगे',
  previous: 'पिछला',
  markReview: 'चिह्नित करें',
  markNext: 'चिह्नित करें और आगे',
  shortcuts: 'कुंजियाँ: 1–6 चुनें · ← → आगे-पीछे · M चिह्नित · C हटाएँ',
  candidate: 'परीक्षार्थी',
  section: 'खंड',
  unmark: 'चिह्न हटाएँ',
  clear: 'उत्तर हटाएँ',
  submit: 'टेस्ट जमा करें',
  allQuestions: 'सभी प्रश्न',
  answered: 'उत्तर दिया',
  notAnswered: 'उत्तर नहीं दिया',
  notVisited: 'नहीं देखा',
  marked: 'चिह्नित',
  answeredMarked: 'उत्तर दिया और चिह्नित',
  saved: 'सेव हो गया',
  saving: 'सेव हो रहा है…',
  offline: 'इंटरनेट नहीं — {n} उत्तर सेव नहीं हुए',
  offlineHint: 'यह पेज खुला रखें। इंटरनेट आते ही उत्तर अपने-आप सेव हो जाएँगे। समय खत्म होने तक जो उत्तर सेव नहीं होंगे, वे नहीं गिने जाएँगे।',
  timeLeft: 'बचा समय',
  confirmSubmit: 'क्या टेस्ट जमा करें?',
  confirmSubmitText: 'जमा करने के बाद उत्तर नहीं बदल सकेंगे।',
  cancel: 'रद्द करें',
  yesSubmit: 'हाँ, जमा करें',
  submittedTitle: 'टेस्ट जमा हो गया',
  submittedText: 'आपके उत्तर सेव हो गए हैं।',
  resultAfterRelease: 'शिक्षक द्वारा परिणाम जारी करने पर यहाँ दिखेगा।',
  backHome: 'होम पर जाएँ',
  timeUp: 'समय समाप्त',
  timeUpText: 'आपके सेव किए गए उत्तर अपने-आप जमा हो गए हैं।',
  openElsewhere: 'यह टेस्ट किसी दूसरे डिवाइस पर खुला है',
  openElsewhereText: 'आप यहाँ जारी रख सकते हैं। दूसरे डिवाइस पर उत्तर सेव होना बंद हो जाएगा।',
  continueHere: 'यहीं जारी रखें',
  fiveMinutesLeft: '5 मिनट बचे हैं',
  oneMinuteLeft: '1 मिनट बचा है',
  loadingTest: 'टेस्ट लोड हो रहा है…',
  score: 'अंक',
  rank: 'रैंक',
  percentile: 'पर्सेंटाइल',
  accuracy: 'सटीकता',
  timeTaken: 'लिया गया समय',
  correct: 'सही',
  wrong: 'गलत',
  skipped: 'छोड़े',
  topper: 'टॉपर',
  average: 'औसत',
  batchRank: '{batch} में रैंक',
  sections: 'खंड',
  topics: 'टॉपिक',
  strong: 'मज़बूत',
  needsWork: 'अभ्यास ज़रूरी',
  solutions: 'हल',
  yourAnswer: 'आपका उत्तर',
  correctAnswer: 'सही उत्तर',
  explanation: 'व्याख्या',
  percentCorrect: '{n}% छात्रों ने सही किया',
  bonusQuestion: 'बोनस — सभी को अंक दिए गए',
  excludedQuestion: 'इस टेस्ट से हटाया गया',
  notAttempted: 'प्रयास नहीं किया',
  shareResult: 'परिणाम शेयर करें',
  leaderboard: 'लीडरबोर्ड',
  you: 'आप',
  updatedAfterCorrection: 'उत्तर कुंजी सुधार के बाद अपडेट किया गया',
  all: 'सभी',
  badge_top10: 'टॉप 10',
  badge_top10pct: 'टॉप 10%',
  badge_rankUp: '{n} रैंक ऊपर',
  badge_personalBest: 'अब तक का सबसे अच्छा',
  badge_fullMarks: 'पूरे अंक',
  badge_firstTest: 'पहला टेस्ट',
  testsTaken: 'दिए गए टेस्ट',
  bestPercentile: 'सबसे अच्छा पर्सेंटाइल',
  averagePercentile: 'औसत पर्सेंटाइल',
  streak: 'लगातार टेस्ट',
  percentileTrend: 'आपका पर्सेंटाइल ग्राफ़',
  allTests: 'सभी टेस्ट',
  noResultsYet: 'पहला परिणाम आने के बाद आपकी प्रगति यहाँ दिखेगी।',
  language: 'भाषा',
  changePassword: 'पासवर्ड बदलें',
  currentPassword: 'मौजूदा पासवर्ड',
  newPassword: 'नया पासवर्ड',
  passwordChanged: 'पासवर्ड बदल गया',
  save: 'सेव करें',
  errorGeneric: 'कुछ गड़बड़ हुई। फिर से कोशिश करें।',
  networkError: 'इंटरनेट कनेक्शन नहीं है।',
  tryAgain: 'फिर से कोशिश करें',
  installApp: 'ऐप इंस्टॉल करें',
  resultCard: 'परिणाम कार्ड',
  participants: '{n} छात्र',
};
